import React from 'react';
import { Icon } from 'antd';
import styles from './UpdateBtn.module.less';

type UpdateBtnProps = {
  timestamp: string | null;
  loading: boolean;
  onClick: () => void;
};
const UpdateBtn: React.FC<UpdateBtnProps> = ({ timestamp, loading, onClick }) => {
  return (
    <div className={styles.updateBtn}>
      <span>
        Last Updated: <b>{timestamp}</b>
      </span>
      <div className={styles.loadingIcon}>
        <Icon onClick={onClick} type="sync" spin={loading} />
      </div>
    </div>
  );
};

export default UpdateBtn;
